import "./ScreenOverlay.css";

interface ScreenOverlayProps {
  apply: boolean;
}

const ScreenOverlay: React.FC<ScreenOverlayProps> = ({ apply = false }) => {
  return (
    <div
      className={`${
        apply
          ? `ScreenOverlay_visible`
          : `ScreenOverlay_hidden`
      }`}
    ></div>
  );
};

export default ScreenOverlay;
